import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-airo-query-confirm-dialog',
  templateUrl: './airo-query-confirm-dialog.component.html',
  styleUrls: ['./airo-query-confirm-dialog.component.scss']
})
export class AiroQueryConfirmDialogComponent {
  queryControl: FormControl;

  constructor(
    public dialogRef: MatDialogRef<AiroQueryConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { query: string }
  ) {
    this.queryControl = new FormControl(this.data?.query || '', [Validators.required]);
  }

  closeModal(): void {
    this.dialogRef.close(false);
  }

  proceed(): void {
    this.queryControl.markAsTouched();
    if (this.queryControl.valid) {
      this.dialogRef.close(this.queryControl.value);
    }
  }
}
